import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import { Leaf, Heart, Users, Award } from 'lucide-react'

const About = () => {
  const values = [
    {
      icon: Leaf,
      title: 'Organic & Fresh',
      description: 'We source only the freshest organic produce from trusted local farms.'
    },
    {
      icon: Heart,
      title: 'Health First',
      description: 'Your health and wellness are at the core of everything we do.'
    },
    {
      icon: Users,
      title: 'Community Focus',
      description: 'Supporting local farmers and building stronger communities together.'
    },
    {
      icon: Award,
      title: 'Quality Assured',
      description: 'Every product goes through rigorous quality checks before reaching you.'
    }
  ]

  return (
    <div data-component-path="client/src/pages/About.jsx" data-component-line="32:5" data-component-id="client/src/pages/About.jsx:32:5">
      <Navbar />
      
      <section data-component-path="client/src/pages/About.jsx" data-component-line="35:7" data-component-id="client/src/pages/About.jsx:35:7" className="pt-24 pb-16 bg-gradient-to-b from-green-50 to-white">
        <div data-component-path="client/src/pages/About.jsx" data-component-line="36:9" data-component-id="client/src/pages/About.jsx:36:9" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div data-component-path="client/src/pages/About.jsx" data-component-line="37:11" data-component-id="client/src/pages/About.jsx:37:11" className="text-center mb-16">
            <h1 data-component-path="client/src/pages/About.jsx" data-component-line="38:13" data-component-id="client/src/pages/About.jsx:38:13" className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              About Fresh Harvest
            </h1>
            <p data-component-path="client/src/pages/About.jsx" data-component-line="41:13" data-component-id="client/src/pages/About.jsx:41:13" className="text-xl text-gray-600 max-w-3xl mx-auto">
              Bringing farm-fresh vegetables and fruits to your table since 2020
            </p>
          </div>

          <div data-component-path="client/src/pages/About.jsx" data-component-line="46:11" data-component-id="client/src/pages/About.jsx:46:11" className="grid md:grid-cols-2 gap-12 items-center mb-20">
            <div data-component-path="client/src/pages/About.jsx" data-component-line="47:13" data-component-id="client/src/pages/About.jsx:47:13">
              <h2 data-component-path="client/src/pages/About.jsx" data-component-line="48:15" data-component-id="client/src/pages/About.jsx:48:15" className="text-4xl font-bold text-gray-900 mb-6">Our Story</h2>
              <p data-component-path="client/src/pages/About.jsx" data-component-line="49:15" data-component-id="client/src/pages/About.jsx:49:15" className="text-gray-600 mb-4 leading-relaxed">
                Fresh Harvest was born from a simple belief: everyone deserves access to fresh, healthy, and affordable produce. What started as a small farmers market stall has grown into a thriving business serving thousands of families.
              </p>
              <p data-component-path="client/src/pages/About.jsx" data-component-line="52:15" data-component-id="client/src/pages/About.jsx:52:15" className="text-gray-600 mb-4 leading-relaxed">
                We work directly with local farmers who share our commitment to sustainable farming practices and quality. This means you get the freshest produce while supporting your local community.
              </p>
              <p data-component-path="client/src/pages/About.jsx" data-component-line="55:15" data-component-id="client/src/pages/About.jsx:55:15" className="text-gray-600 leading-relaxed">
                Every day, we hand-pick the best vegetables and fruits, ensuring that only the highest quality produce makes it to your door. Our promise is simple: fresh, healthy, and delicious.
              </p>
            </div>
            <div data-component-path="client/src/pages/About.jsx" data-component-line="59:13" data-component-id="client/src/pages/About.jsx:59:13" className="relative h-96 rounded-2xl overflow-hidden shadow-2xl">
              <img 
                data-component-path="client/src/pages/About.jsx" 
                data-component-line="61:17" 
                data-component-id="client/src/pages/About.jsx:61:17"
                src="https://images.pexels.com/photos/1300972/pexels-photo-1300972.jpeg?auto=compress&cs=tinysrgb&w=1200"
                alt="Fresh produce at farmers market"
                className="w-full h-full object-cover"
                loading="lazy"
                onError={(e) => {
                  e.target.src = 'https://images.pexels.com/photos/264537/pexels-photo-264537.jpeg?auto=compress&cs=tinysrgb&w=1200'
                }}
              />
            </div>
          </div>

          <div data-component-path="client/src/pages/About.jsx" data-component-line="75:11" data-component-id="client/src/pages/About.jsx:75:11" className="mb-16">
            <h2 data-component-path="client/src/pages/About.jsx" data-component-line="76:13" data-component-id="client/src/pages/About.jsx:76:13" className="text-4xl font-bold text-center text-gray-900 mb-12">Our Values</h2>
            <div data-component-path="client/src/pages/About.jsx" data-component-line="77:13" data-component-id="client/src/pages/About.jsx:77:13" className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {values.map((value, index) => (
                <div 
                  key={index}
                  data-component-path="client/src/pages/About.jsx" 
                  data-component-line="81:19" 
                  data-component-id={`client/src/pages/About.jsx:81:19-${index}`}
                  className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  <div data-component-path="client/src/pages/About.jsx" data-component-line="86:19" data-component-id={`client/src/pages/About.jsx:86:19-${index}`} className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
                    <value.icon data-component-path="client/src/pages/About.jsx" data-component-line="87:21" data-component-id={`client/src/pages/About.jsx:87:21-${index}`} className="w-8 h-8 text-green-600" />
                  </div>
                  <h3 data-component-path="client/src/pages/About.jsx" data-component-line="89:19" data-component-id={`client/src/pages/About.jsx:89:19-${index}`} className="text-xl font-bold text-gray-900 mb-2">{value.title}</h3>
                  <p data-component-path="client/src/pages/About.jsx" data-component-line="90:19" data-component-id={`client/src/pages/About.jsx:90:19-${index}`} className="text-gray-600">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default About